import { History } from "history";

import {
  SubjectDto,
  PaginateQuery,
  CreateSubjectRequest,
  UpdateSubjectRequest,
  CopyCutSubjectRequest,
  PurchaseableSubjectStudentDto,
  ManualPurchaseRequest,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";
import { MediaDto } from "../../interfaces/media";

export const GET_SUBJECTS_BY_GRADE = "GET_SUBJECTS_BY_GRADE";
export const GET_SUBJECTS_BY_GRADE_SUCCESS: any =
  "GET_SUBJECTS_BY_GRADE_SUCCESS";
export const GET_SUBJECTS_BY_GRADE_ERROR: any = "GET_SUBJECTS_BY_GRADE_ERROR";
export const RESET_SUBJECTS_BY_GRADE: any = "RESET_SUBJECTS_BY_GRADE";

//#region Get Subjects by Grade

export interface GetSubjectsByGradeAction {
  type: typeof GET_SUBJECTS_BY_GRADE;
  payload: { gradeId: string };
}

export interface GetSubjectsByGradeSuccessAction {
  type: typeof GET_SUBJECTS_BY_GRADE_SUCCESS;
  payload: SubjectDto[];
}

export interface GetSubjectsByGradeErrorAction {
  type: typeof GET_SUBJECTS_BY_GRADE_ERROR;
  payload: any;
}

export interface ResetSubjectsByGradeAction {
  type: typeof RESET_SUBJECTS_BY_GRADE;
  payload: any;
}

//#endregion

//#region Get Subjects

export const GET_SUBJECTS = "GET_SUBJECTS";
export const GET_SUBJECTS_SUCCESS: any = "GET_SUBJECTS_SUCCESS";
export const GET_SUBJECTS_ERROR: any = "GET_SUBJECTS_ERROR";

export interface GetSubjectsAction {
  type: typeof GET_SUBJECTS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetSubjectsSuccessAction {
  type: typeof GET_SUBJECTS_SUCCESS;
  payload: Paginated<SubjectDto>;
}

export interface GetSubjectsErrorAction {
  type: typeof GET_SUBJECTS_ERROR;
  payload: any;
}
//#endregion

//#region Get Subject

export const GET_SUBJECT = "GET_SUBJECT";
export const GET_SUBJECT_SUCCESS: any = "GET_SUBJECT_SUCCESS";
export const GET_SUBJECT_ERROR: any = "GET_SUBJECT_ERROR";

export interface GetSubjectAction {
  type: typeof GET_SUBJECT;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetSubjectSuccessAction {
  type: typeof GET_SUBJECT_SUCCESS;
  payload: SubjectDto;
}

export interface GetSubjectErrorAction {
  type: typeof GET_SUBJECT_ERROR;
  payload: any;
}
//#endregion

//#region Add Subject

export const ADD_SUBJECT = "ADD_SUBJECT";
export const ADD_SUBJECT_SUCCESS: any = "ADD_SUBJECT_SUCCESS";
export const ADD_SUBJECT_ERROR: any = "ADD_SUBJECT_ERROR";

export interface AddSubjectAction {
  type: typeof ADD_SUBJECT;
  payload: {
    request: CreateSubjectRequest;
    history: History;
  };
}

export interface AddSubjectSuccessAction {
  type: typeof ADD_SUBJECT_SUCCESS;
  payload: null;
}

export interface AddSubjectErrorAction {
  type: typeof ADD_SUBJECT_ERROR;
  payload: any;
}
//#endregion

//#region Update Subject

export const UPDATE_SUBJECT = "UPDATE_SUBJECT";
export const UPDATE_SUBJECT_SUCCESS: any = "UPDATE_SUBJECT_SUCCESS";
export const UPDATE_SUBJECT_ERROR: any = "UPDATE_SUBJECT_ERROR";

export interface UpdateSubjectAction {
  type: typeof UPDATE_SUBJECT;
  payload: {
    id: string;
    request: UpdateSubjectRequest;
    history: History;
  };
}

export interface UpdateSubjectSuccessAction {
  type: typeof UPDATE_SUBJECT_SUCCESS;
  payload: null;
}

export interface UpdateSubjectErrorAction {
  type: typeof UPDATE_SUBJECT_ERROR;
  payload: any;
}
//#endregion

//#region Delete Subject

export const DELETE_SUBJECT_CONSENT: any = "DELETE_SUBJECT_CONSENT";
export const DELETE_SUBJECT = "DELETE_SUBJECT";
export const DELETE_SUBJECT_SUCCESS: any = "DELETE_SUBJECT_SUCCESS";
export const DELETE_SUBJECT_ERROR: any = "DELETE_SUBJECT_ERROR";

export interface DeleteSubjectConsentAction {
  type: typeof DELETE_SUBJECT_CONSENT;
  payload: string;
}

export interface DeleteSubjectAction {
  type: typeof DELETE_SUBJECT;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteSubjectSuccessAction {
  type: typeof DELETE_SUBJECT_SUCCESS;
  payload: null;
}

export interface DeleteSubjectErrorAction {
  type: typeof DELETE_SUBJECT_ERROR;
  payload: any;
}
//#endregion

//#region Upload Subject Home Image

export const UPLOAD_SUBJECT_HOME_IMAGE = "UPLOAD_SUBJECT_HOME_IMAGE";
export const UPLOAD_SUBJECT_HOME_IMAGE_SUCCESS: any =
  "UPLOAD_SUBJECT_HOME_IMAGE_SUCCESS";
export const UPLOAD_SUBJECT_HOME_IMAGE_ERROR: any =
  "UPLOAD_SUBJECT_HOME_IMAGE_ERROR";

export interface UploadSubjectHomeImageAction {
  type: typeof UPLOAD_SUBJECT_HOME_IMAGE;
  payload: {
    file: File;
    history: History;
    subjectId?: string;
  };
}
export interface UploadSubjectHomeImageSuccessAction {
  type: typeof UPLOAD_SUBJECT_HOME_IMAGE_SUCCESS;
  payload: MediaDto;
}

export interface UploadSubjectHomeImageErrorAction {
  type: typeof UPLOAD_SUBJECT_HOME_IMAGE_ERROR;
  payload: any;
}
//#endregion

//#region Upload Subject Content Image

export const UPLOAD_SUBJECT_CONTENT_IMAGE = "UPLOAD_SUBJECT_CONTENT_IMAGE";
export const UPLOAD_SUBJECT_CONTENT_IMAGE_SUCCESS: any =
  "UPLOAD_SUBJECT_CONTENT_IMAGE_SUCCESS";
export const UPLOAD_SUBJECT_CONTENT_IMAGE_ERROR: any =
  "UPLOAD_SUBJECT_CONTENT_IMAGE_ERROR";

export interface UploadSubjectContentImageAction {
  type: typeof UPLOAD_SUBJECT_CONTENT_IMAGE;
  payload: {
    file: File;
    history: History;
    subjectId?: string;
  };
}
export interface UploadSubjectContentImageSuccessAction {
  type: typeof UPLOAD_SUBJECT_CONTENT_IMAGE_SUCCESS;
  payload: MediaDto;
}

export interface UploadSubjectContentImageErrorAction {
  type: typeof UPLOAD_SUBJECT_CONTENT_IMAGE_ERROR;
  payload: any;
}
//#endregion

//#region Copy Cut Subject

export const COPY_CUT_SUBJECT = "COPY_CUT_SUBJECT";
export const COPY_CUT_SUBJECT_SUCCESS: any = "COPY_CUT_SUBJECT_SUCCESS";
export const COPY_CUT_SUBJECT_ERROR: any = "COPY_CUT_SUBJECT_ERROR";
export const RESET_COPY_CUT_SUBJECT: any = "RESET_COPY_CUT_SUBJECT";

export interface CopyCutSubjectAction {
  type: typeof COPY_CUT_SUBJECT;
  payload: {
    request: CopyCutSubjectRequest;
    history: History;
  };
}

export interface CopyCutSubjectSuccessAction {
  type: typeof COPY_CUT_SUBJECT_SUCCESS;
  payload: null;
}

export interface CopyCutSubjectErrorAction {
  type: typeof COPY_CUT_SUBJECT_ERROR;
  payload: any;
}

export interface ResetCopyCutSubjectAction {
  type: typeof RESET_COPY_CUT_SUBJECT;
  payload: any;
}

//#endregion

//#region Toggle Subject State

export const TOGGLE_SUBJECT_STATE_CONSENT: any = "TOGGLE_SUBJECT_STATE_CONSENT";
export const TOGGLE_SUBJECT_STATE = "TOGGLE_SUBJECT_STATE";
export const TOGGLE_SUBJECT_STATE_SUCCESS: any = "TOGGLE_SUBJECT_STATE_SUCCESS";
export const TOGGLE_SUBJECT_STATE_ERROR: any = "TOGGLE_SUBJECT_STATE_ERROR";

export interface ToggleSubjectStateConsentAction {
  type: typeof TOGGLE_SUBJECT_STATE_CONSENT;
  payload: string;
}

export interface ToggleSubjectStateAction {
  type: typeof TOGGLE_SUBJECT_STATE;
  payload: {
    id: string;
    history: History;
  };
}

export interface ToggleSubjectStateSuccessAction {
  type: typeof TOGGLE_SUBJECT_STATE_SUCCESS;
  payload: { id: string };
}

export interface ToggleSubjectStateErrorAction {
  type: typeof TOGGLE_SUBJECT_STATE_ERROR;
  payload: any;
}
//#endregion

//#region Subject select list by grade

export const GET_SUBJECT_LIST_BY_GRADE = "GET_SUBJECT_LIST_BY_GRADE";
export const GET_SUBJECT_LIST_BY_GRADE_SUCCESS: any =
  "GET_SUBJECT_LIST_BY_GRADE_SUCCESS";
export const GET_SUBJECT_LIST_BY_GRADE_ERROR: any =
  "GET_SUBJECT_LIST_BY_GRADE_ERROR";

export const RESET_SUBJECT_LIST_BY_GRADE: any = "RESET_SUBJECT_LIST_BY_GRADE";

export interface GetSubjectSelectListByGradeAction {
  type: typeof GET_SUBJECT_LIST_BY_GRADE;
  payload: { gradeId: string };
}

export interface GetSubjectSelectListByGradeSuccessAction {
  type: typeof GET_SUBJECT_LIST_BY_GRADE_SUCCESS;
  payload: SelectListDto[];
}

export interface GetSubjectSelectListByGradeErrorAction {
  type: typeof GET_SUBJECT_LIST_BY_GRADE_ERROR;
  payload: any;
}

export interface ResetSubjectSelectListByGradeAction {
  type: typeof RESET_SUBJECT_LIST_BY_GRADE;
  payload: any;
}

//#endregion

//#region Get Purchase Subjects for Student by providing course and grade id

export const GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT =
  "GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT";
export const GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_SUCCESS: any =
  "GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_SUCCESS";
export const GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_ERROR: any =
  "GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_ERROR";
export const RESET_PURCHASEABLE_SUBJECTS_FOR_STUDENT: any =
  "RESET_PURCHASEABLE_SUBJECTS_FOR_STUDENT";

export interface GetPurchaseableSubjectForStudentAction {
  type: typeof GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT;
  payload: { courseId: string; gradeId: string; userId: string };
}

export interface GetPurchaseableSubjectForStudentSuccessAction {
  type: typeof GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_SUCCESS;
  payload: PurchaseableSubjectStudentDto[];
}

export interface GetPurchaseableSubjectForStudentErrorAction {
  type: typeof GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_ERROR;
  payload: any;
}

export interface ResetPurchaseableSubjectForStudentAction {
  type: typeof RESET_PURCHASEABLE_SUBJECTS_FOR_STUDENT;
  payload: any;
}

//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetSubjectsByGradeAction
  | GetSubjectsByGradeSuccessAction
  | GetSubjectsByGradeErrorAction
  | ResetSubjectsByGradeAction
  | GetSubjectAction
  | GetSubjectSuccessAction
  | GetSubjectErrorAction
  | AddSubjectAction
  | AddSubjectSuccessAction
  | AddSubjectErrorAction
  | UpdateSubjectAction
  | UpdateSubjectSuccessAction
  | UpdateSubjectErrorAction
  | DeleteSubjectAction
  | DeleteSubjectSuccessAction
  | DeleteSubjectErrorAction
  | UploadSubjectHomeImageAction
  | UploadSubjectHomeImageSuccessAction
  | UploadSubjectHomeImageErrorAction
  | UploadSubjectContentImageAction
  | UploadSubjectContentImageSuccessAction
  | UploadSubjectContentImageErrorAction
  | CopyCutSubjectAction
  | CopyCutSubjectSuccessAction
  | CopyCutSubjectErrorAction
  | ToggleSubjectStateAction
  | ToggleSubjectStateSuccessAction
  | ToggleSubjectStateErrorAction
  | GetSubjectSelectListByGradeAction
  | GetSubjectSelectListByGradeSuccessAction
  | GetSubjectSelectListByGradeErrorAction
  | ResetSubjectSelectListByGradeAction
  | GetPurchaseableSubjectForStudentAction
  | GetPurchaseableSubjectForStudentSuccessAction
  | GetPurchaseableSubjectForStudentErrorAction
  | ResetPurchaseableSubjectForStudentAction;
